import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
import { CHECKOUT_URLS } from '../lib/checkoutLinks';
export function NewOffers() {
  return <Section id="ofertas" className="bg-cream-warm py-20 scroll-mt-16" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-12" data-id="element-178">
          Elegí tu opción y empezá esta noche
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-stretch" data-id="element-179">
          {/* Oferta Básica */}
          <Card className="p-8 bg-white border-sage-mist flex flex-col" data-id="element-180">
            <h3 className="text-2xl font-bold text-forest-deep mb-4 text-center" data-id="element-181">
              Hogar Natural
            </h3>
            <div className="text-4xl font-bold text-forest-deep text-center mb-8" data-id="element-182">
              $17.999{' '}
              <span className="text-xl font-normal text-forest/70" data-id="element-183">ARS</span>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-184">
              <li className="flex items-start gap-3" data-id="element-185">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-186" />
                <span className="text-forest-deep" data-id="element-187">
                  Los 5 tomos completos en formato digital
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-188">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-189" />
                <span className="text-forest-deep" data-id="element-190">
                  Acceso inmediato desde cualquier dispositivo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-191">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-192" />
                <span className="text-forest-deep" data-id="element-193">
                  Tuyo para siempre sin vencimiento
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-194">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-195" />
                <span className="text-forest-deep" data-id="element-196">
                  Garantía de devolución total
                </span>
              </li>
            </ul>

            <Button variant="secondary" size="lg" fullWidth href={CHECKOUT_URLS.hogarNatural} className="bg-forest-light hover:bg-forest text-white" data-id="element-197">
              QUIERO ACCESO INMEDIATO — $17.999
            </Button>
          </Card>

          {/* Oferta Destacada */}
          <Card className="p-8 bg-white border-2 border-honey shadow-xl flex flex-col relative" data-id="element-198">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-honey text-forest-deep px-6 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider shadow-md" data-id="element-199">
              MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold text-forest-deep mb-4 text-center mt-2" data-id="element-200">
              Tu Super Pack de Hogar Natural en Casa
            </h3>
            <div className="text-4xl font-bold text-forest-deep text-center mb-8" data-id="element-201">
              $27.999{' '}
              <span className="text-xl font-normal text-forest/70" data-id="element-202">ARS</span>
            </div>

            <ul className="space-y-4 mb-10 flex-grow" data-id="element-203">
              <li className="flex items-start gap-3" data-id="element-204">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-205" />
                <span className="text-forest-deep font-medium" data-id="element-206">
                  Los 5 tomos completos en formato digital
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-207">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-208" />
                <span className="text-forest-deep font-medium" data-id="element-209">
                  Los 5 bonos con valor total de $20.995 ARS
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-210">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-211" />
                <span className="text-forest-deep font-medium" data-id="element-212">
                  Acceso inmediato desde cualquier dispositivo
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-213">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-214" />
                <span className="text-forest-deep font-medium" data-id="element-215">
                  Tuyo para siempre sin vencimiento
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-216">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-217" />
                <span className="text-forest-deep font-medium" data-id="element-218">
                  Garantía de devolución total
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-219">
                <Check className="w-5 h-5 text-honey-dark shrink-0 mt-0.5" data-id="element-220" />
                <span className="text-forest-deep font-medium" data-id="element-221">
                  La colección completa para cuidar a toda tu familia
                </span>
              </li>
            </ul>

            <Button variant="primary" size="lg" fullWidth href={CHECKOUT_URLS.superPack} className="bg-forest-deep hover:bg-forest text-white font-bold text-lg py-4" data-id="element-222">
              QUIERO EL SISTEMA COMPLETO — $27.999
            </Button>
          </Card>
        </div>
      </div>
    </Section>;
}